import Vue from 'vue'
import XREditHead  from './editHead'

export default XREditHead




// WEBPACK FOOTER //
// ./src/components/usercenter/editHead/index.js